"use strict";
import getters from './getters';
import actions from './actions';

export default {
    namespaced: true,
    state: () => ({
        _accessToken: '',
        _refreshToken: '',

        _clientUuid: '',
        _thirdPartyUuid: '',
        _thirdPartyInternRedirect: '',
        _thirdPartyPlatformList: null,

        _authenticating: false,
        _authenticationErrorCode: 0,
        _authenticationError: '',
        _sellerAgent: {},

        _me: {},
        _proxyByV2: false,
        _sspToken: null,
    }),
    getters,
    actions,
};